'use client'

import { useSwiperWidth } from '@/hooks/useSwiperWidth'
import type { FC } from 'react'
import { useId, useRef } from 'react'
import type { Swiper as SwiperType } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ControlTab } from '../atoms/ControlTab'
import type { TabType } from '../blocks/TabsBlock'

// Import Swiper styles
import 'swiper/css'

export type ControlTabHeaderProps = {
	tabs: TabType[]
	activeTab: number
	onChange: (tab: number) => void
}

export const ControlTabHeader: FC<ControlTabHeaderProps> = ({ tabs, activeTab, onChange }) => {
	const swiperRef = useRef<SwiperType | null>(null)

	const swiperWidth = useSwiperWidth(swiperRef)
	const swiperId = useId()
	return (
		<>
			<style jsx global>{`
				#${swiperId} .swiper-wrapper::after {
					content: '';
					position: absolute;
					bottom: 0;
					left: 0;
					border-bottom: 1px solid var(--color-grey-20);
					width: ${swiperWidth}px;
					pointer-events: none;
				}
			`}</style>
			<Swiper
				onSwiper={(swiper) => {
					swiperRef.current = swiper
				}}
				slidesPerView={'auto'}
				spaceBetween={16}
				navigation={false}
				centeredSlides={false}
				loop={false}
				breakpoints={{
					1280: {
						spaceBetween: 24,
					},
				}}
				id={swiperId}
				className="w-full !overflow-visible"
			>
				{tabs.map((tab, index) => (
					<SwiperSlide key={tab.title || index} className="!w-auto !opacity-100">
						<ControlTab
							title={tab.title}
							active={activeTab === index}
							id={`tab-${index}-button`}
							aria-controls={`tab-${index}-content`}
							onClick={() => {
								onChange(index)
							}}
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</>
	)
}
